import { useState } from 'react';
import ReactGA from 'react-ga4';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'src/componentes/dropdown';
import { useIntl } from 'react-intl';
import { cn } from 'cn';
import { useHistory } from 'react-router-dom';

import ContentManager from 'src/componentes/content-manager';
import LucideIcon from 'src/componentes/lucide-icon';
import useAuth from 'src/hooks/useAuth';
import FormDemo from './FormDemo';
import { MODULOS } from 'src/utils/constants';
import { acessarFrstClick } from 'src/componentes/AcessarFrstClick';
import { acessarHefloClick } from 'src/componentes/AcessarHefloClick';
import Badge from 'src/componentes/Badge';

function NavbarModules() {
  const intl = useIntl();
  const history = useHistory();

  const { module, modules, setModule, user } = useAuth();

  const [demoId, setDemoId] = useState(null);

  const renderDemo = () => (
    <Badge className="w-100">
      {intl.formatMessage({ id: 'label.soliciteUmaDemo' })}
    </Badge>
  );

  const handleFormDemo = (m) => {
    ContentManager.addContent(<FormDemo module={m} />);
  };

  const handleChangeModule = (m) => {
    ReactGA.event('troca_de_modulo', {
      category: 'modulo_navbar',
      action: `${m?.abreviacao}`,
      label: user?.nome,
    });
    setModule(m);
    history.push('/');
  };

  return (
    <UncontrolledDropdown className="nav-item">
      <DropdownToggle asChild>
        <a
          role="button"
          tabIndex={0}
          className="nav-link nav-flag mr-3 p-0 tw:cursor-pointer"
        >
          <div className="d-flex align-items-center">
            <span className="mx-2 text-dark">{module?.nome}</span>
            <LucideIcon icon="chevron-down" size={18} />
          </div>
        </a>
      </DropdownToggle>
      <DropdownMenu end className="tw:min-w-70 tw:px-0 tw:py-2">
        {modules &&
          modules.length > 0 &&
          modules
            .filter(
              (e) => e.visivel && e.id !== MODULOS.INTELIGENCIA_ARTIFICIAL
            )
            .map((m) => {
              const isDemo = demoId === m.id;
              const show = m.exibir;
              const active = m.id === module.id;
              const isFRST = m.id === MODULOS.FRST;
              const isHEFLO = m.id === MODULOS.HEFLO;

              return (
                <DropdownItem
                  style={{ minHeight: 35 }}
                  className={cn(
                    'tw:rounded-none tw:px-6',
                    active &&
                      'tw:bg-primary tw:text-primary-foreground tw:focus:bg-primary tw:focus:text-primary-foreground',
                    !active && !show && 'text-muted'
                  )}
                  onMouseEnter={() => !show && setDemoId(m.id)}
                  onMouseLeave={() => setDemoId(null)}
                  onClick={() =>
                    isFRST
                      ? acessarFrstClick(intl)
                      : isHEFLO
                        ? acessarHefloClick()
                        : show
                          ? handleChangeModule(m)
                          : handleFormDemo(m)
                  }
                >
                  {isDemo ? (
                    renderDemo()
                  ) : (
                    <div className="d-flex align-items-center tw:w-full">
                      <div className="w-75">
                        <span className="align-middle">{m.nome}</span>
                      </div>
                    </div>
                  )}
                </DropdownItem>
              );
            })}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}

export default NavbarModules;
